import { ImageFormat } from '../services/imageService';

export interface ConversionPair {
  slug: string;
  from: ImageFormat;
  to: ImageFormat;
  tier: 1 | 2 | 3;
}

export const conversions: ConversionPair[] = [
  // Tier 1 - Highest search volume
  { slug: 'png-to-jpg', from: 'png', to: 'jpeg', tier: 1 },
  { slug: 'jpg-to-png', from: 'jpeg', to: 'png', tier: 1 },
  { slug: 'png-to-webp', from: 'png', to: 'webp', tier: 1 },
  { slug: 'jpg-to-webp', from: 'jpeg', to: 'webp', tier: 1 },

  // Tier 2 - High volume
  { slug: 'webp-to-png', from: 'webp', to: 'png', tier: 2 },
  { slug: 'webp-to-jpg', from: 'webp', to: 'jpeg', tier: 2 },
  { slug: 'svg-to-png', from: 'svg', to: 'png', tier: 2 },
  { slug: 'png-to-avif', from: 'png', to: 'avif', tier: 2 },
  { slug: 'jpg-to-avif', from: 'jpeg', to: 'avif', tier: 2 },

  // Tier 3 - Moderate volume
  { slug: 'gif-to-png', from: 'gif', to: 'png', tier: 3 },
  { slug: 'bmp-to-jpg', from: 'bmp', to: 'jpeg', tier: 3 },
  { slug: 'png-to-gif', from: 'png', to: 'gif', tier: 3 },
  { slug: 'jpg-to-gif', from: 'jpeg', to: 'gif', tier: 3 },
  { slug: 'png-to-ico', from: 'png', to: 'ico', tier: 3 },
  { slug: 'png-to-bmp', from: 'png', to: 'bmp', tier: 3 },
  { slug: 'svg-to-jpg', from: 'svg', to: 'jpeg', tier: 3 },
];

export const getConversionBySlug = (slug: string): ConversionPair | undefined => {
  return conversions.find(c => c.slug === slug);
};

export const getConversionsByTier = (tier: 1 | 2 | 3): ConversionPair[] => {
  return conversions.filter(c => c.tier === tier);
};

export const getConversionsFromFormat = (format: ImageFormat): ConversionPair[] => {
  return conversions.filter(c => c.from === format);
};
